import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Admin } from '@/types/admin';
import { getFullName } from '@/utils/name';
import { pages } from '@/settings/pages';

import * as styles from './index.module.scss';
import { RowItem, RowItemProps } from './RowItem';

type Props = {
  admin: Admin;
};

export const AccountMenu: FC<Props> = ({ admin }) => {
  const { t } = useTranslation();

  const items: RowItemProps[] = [
    {
      label: t('models.admin.name'),
      value: (
        <>
          {getFullName(admin.firstName, admin.lastName)}
          &nbsp; ({getFullName(admin.kanaFirstName, admin.kanaLastName)})
        </>
      ),
      link: pages.account.name.edit,
      dataTest: 'name-edit-link',
    },
    {
      label: t('ui.password.label'),
      value: '****************',
      link: pages.account.password.edit,
      dataTest: 'password-edit-link',
    },
    {
      label: t('models.admin.email'),
      value: admin.email,
    },
  ];

  return (
    <div className={styles.root}>
      {items.map((item, index) => (
        <RowItem
          key={index}
          label={item.label}
          value={item.value}
          link={item.link}
          dataTest={item.dataTest}
        />
      ))}
    </div>
  );
};
